import addTicketTypeRelation from './add-ticket-type-relation';
import cleanup from './cleanup';
import createGroup from './create-group';
import createTemplate from './create-template';
import getGroups from './get-groups';
import getRemoveGroupGuard from './get-remove-group-guard';
import getTicketTypes from './get-ticket-types';
import removeGroup from './remove-group';
import removeTicketTypeRelation from './remove-ticket-type-relation';
import reorderGroups from './reorder-groups';
import reorderTicketTypes from './reorder-ticket-types';
import setRelationships from './set-relationships';
import updateGroup from './update-group';

const actions = {
	addTicketTypeRelation,
	cleanup,
	createGroup,
	createTemplate,
	getGroups,
	getRemoveGroupGuard,
	getTicketTypes,
	removeGroup,
	removeTicketTypeRelation,
	reorderGroups,
	reorderTicketTypes,
	setRelationships,
	updateGroup,
} as const;

export type Actions = typeof actions;
export default actions;
